/*
  Add Custom JS to be layered on top of ciritical theme js
*/

const CartMessage = {
  tag: '',
  specificTitle: '',
  maxItemsToShow: 0,

  init: () => {
    const messageElement = document.getElementById('cart-message');

    if (!messageElement) return;

    CartMessage.tag = messageElement.dataset.tag;
    CartMessage.specificTitle = messageElement.dataset.title;
    CartMessage.maxItemsToShow = messageElement.dataset.after;

    console.log('CartMessage', CartMessage);
  },

  checkCartItems: () => {
    const cartItems = Neptune.liquid.items.Cart.data.items;
    let shouldShowMessage = false;

    if (!shouldShowMessage && CartMessage.tag != undefined) {
      shouldShowMessage = cartItems.some(item => item.properties._message === 'cart');
    }  

    if (!shouldShowMessage && CartMessage.specificTitle !== undefined) {
      const normalizedSpecificTitle = CartMessage.specificTitle.trim().toLowerCase();
      shouldShowMessage = cartItems.some(item => item.product_title.trim().toLowerCase().includes(normalizedSpecificTitle));
    }

    if (CartMessage.tag == undefined && CartMessage.specificTitle == undefined) {
      shouldShowMessage = true;
    }

    if (CartMessage.maxItemsToShow > 0 && cartItems.length > CartMessage.maxItemsToShow) {
      shouldShowMessage = false;
    }

    CartMessage.showOrHideMessage(shouldShowMessage);
  },

  showOrHideMessage: (show) => {
    const messageElement = document.getElementById('cart-message');

    if (show) {
      messageElement.classList.remove('hidden');
      messageElement.classList.add('block');
    } else {
      messageElement.classList.add('hidden');
      messageElement.classList.remove('block');
    }
  },

  run: () => {
    CartMessage.init();
    CartMessage.checkCartItems();
  }
}

window.CartMessage = CartMessage;

document.addEventListener('DOMContentLoaded', function() {
  CartMessage.run();
});

document.addEventListener('cart:itemAdded', function() {
  setTimeout(() => {
    CartMessage.run();
  }, 500);
});

document.addEventListener('DOMContentLoaded', function() {
  window.handleUpcartOpen = function (event) {
    if (typeof window.upcartOpenCart === 'function') {
      // upcart cart-drawer open event
      window.upcartOpenCart();
    }
  };

  // upcart loaded event
  window.upcartOnCartLoaded = (cart) => {
    const bubbleWrapper = document.querySelector('.tools__cart--bubble');
    const bubble = bubbleWrapper?.querySelector('span');

    if (!bubbleWrapper || !bubble) return;

    const themeCartCount = parseInt(bubble.textContent.trim(), 10) || 0;
    const appCartCount = cart.item_count;

    // Sync theme cart count with UpCart
    if (themeCartCount !== appCartCount) {
      if (appCartCount === 0) {
        bubbleWrapper.remove();
        return;
      }

      bubble.textContent = appCartCount;
    }
  };
});

// Sync cart state when user navigates back using the browser's back button
(function () {

  function getBubbleCount() {
    var bubble = document.querySelector('.tools__cart--bubble span');
    if (!bubble) return null;
    return parseInt(bubble.textContent.trim(), 10) || 0;
  }

  function updateCartIfCountMismatch(event) {
    //console.log("Cart newly event",event)
    var domCount = getBubbleCount();

    fetch(window.Shopify.routes.root + 'cart.js', {
      credentials: 'include'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Shopify cart.item_count is the source of truth
        if (domCount !== cart.item_count) {
          Neptune.cart.onCartUpdate(cart);
          //console.log("cart synced on browser back button....");
        }
      });
  }

  // Chrome / Firefox back button
  window.addEventListener('popstate', function () {
    updateCartIfCountMismatch();
  });

  // Safari BFCache restore
  window.addEventListener('pageshow', function (event) {
    updateCartIfCountMismatch(event);
  });

})();
